import { ChangeEvent } from 'react'

import * as UI from '@/components/componentLibrary'

import { EditableFieldProps } from '../types'

import './index.scss'

export const PolicyName = ({ editPolicy, onValidate, policy, ...props }: EditableFieldProps) => {
  return (
    <UI.Input
      className="policies-table-form-policy-name-input"
      onBlur={onValidate}
      onChange={(e: ChangeEvent<HTMLInputElement>) =>
        editPolicy?.(p => p.setPolicyName(e.target.value))
      }
      value={policy?.policyName}
      {...props}
    />
  )
}
